import styled from 'styled-components';
import { normalizeWidth } from '../../../utils/normalize';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  // width: ${normalizeWidth(319)};
  min-width: 319px;
  max-width: 400px;
  gap: 16px;
  box-shadow: 0px 2px 14px 0px rgba(140, 135, 150, 0.3);
  background-color: #FFF;
  z-index: 1;
  border-radius: 8px;
`;

export const DescriptionSection = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 319px;
`;

export const Description = styled.p`
  font-size: 12px;
  color: rgba(27, 27, 27, 1);
  font-family: Inter-Regular;
  font-weight: 400;
  max-width: 319px;
  word-wrap: break-word;
  max-height: 400px;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;
  font-family: Inter-Regular;
  font-weight: 400;
  font-size: 12px;
`;

export const ButtonItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`;